import React from 'react';
import { SizeNotice } from '../../SizeGuide.css';
import { men as menData } from '../../SizeGuideData';
import { renderTable } from '../../size_guide_helpers';

const men = () => [
  { tab: 'tab_clothing', label: 'Clothing', contentGenerator: () => renderTable(menData.clothing) },
  { tab: 'tab_shirts', label: 'Shirts', contentGenerator: () => renderTable(menData.shirts) },
  {
    tab: 'tab_jeans',
    label: 'Jeans',
    contentGenerator: () => (
      <>
        {renderTable(menData.jeans.waist)}
        {renderTable(menData.jeans.length)}
      </>
    ),
  },
  { tab: 'tab_shoes', label: 'Shoes', contentGenerator: () => renderTable(menData.shoes, 0, false) },
  {
    tab: 'tab_hats',
    label: 'Hats',
    contentGenerator: () => (
      <>
        {renderTable(menData.hats)}
        <SizeNotice>{menData.hats_notice}</SizeNotice>
      </>
    ),
  },
  {
    tab: 'tab_gloves',
    label: 'Gloves',
    contentGenerator: () => (
      <>
        {renderTable(menData.gloves)}
        <SizeNotice>{menData.gloves_notice}</SizeNotice>
      </>
    ),
  },
  { tab: 'tab_belts', label: 'Belts', contentGenerator: () => renderTable(menData.belts) },
  { tab: 'tab_rings', label: 'Rings', contentGenerator: () => renderTable(menData.rings) },
];

export default men;
